import { render, staticRenderFns } from "./PatientNotesComponent.vue?vue&type=template&id=35835490"
import script from "./PatientNotesComponent.vue?vue&type=script&lang=js"
export * from "./PatientNotesComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports